"use strict";var e=require("styled-components");require("../../providers/Theme/defaultTheme.js");var i=require("../../utilities/theme/createStyles/index.js");const t={small:"9px 14px",medium:"17px",large:"20px"},o=e.css`
    position: relative;
    z-index: 1;
    cursor: ${({disabled:e})=>e?"initial":"pointer"};
    outline: none;
    border: none;
    background: transparent;
    ${({theme:e})=>i(e.typography.button)}
    outline: ${({theme:e,color:i=e.colors.primary.default,variant:t="fill"})=>`solid 1px ${"flat"===t?"transparent":i}`};
    border-radius: 2px;
    color: ${({theme:e,variant:i="fill",color:t=e.colors.primary.default})=>"outline"===i||"flat"===i?t:e.colors.common[e.mode]};
    padding: ${({size:e="medium"})=>t[e]};
    display: inline-grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
    align-items: center;
    opacity: ${({disabled:e})=>e?.5:1};
    text-decoration: none;
    width: ${({fullwidth:e=!1})=>e?"100%":"max-content"};

    > * {
        height: 1em;
    }

    > .background {
        display: block;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${({theme:e,color:i=e.colors.primary.default})=>i};
        opacity: ${({variant:e="fill"})=>"fill"===e?1:0};
        transition: all 0.2s ease-in-out;
        border-radius: 2px;
    }

    &:not(:disabled) {
        &:hover,
        &:active,
        &:focus {
            > .background {
                opacity: ${({variant:e="fill"})=>"fill"===e?1:.1};
                filter: ${({variant:e="fill"})=>"fill"===e?"brightness(120%)":"none"};
            }
        }
    }
`;module.exports=o;
//# sourceMappingURL=styles.js.map
